import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <main className="pt-20">
        <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <h1 className="text-5xl font-bold text-navy mb-6">
              Privacy Policy
            </h1>
            <p className="text-sm text-gray-600">
              Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>
        </section>

        <section className="py-12 pb-24">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <div className="prose prose-lg max-w-none">
              <h2 className="text-2xl font-bold text-navy mb-4">Introduction</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                This Privacy Policy describes how we collect, use, and protect your personal information when you use our funding strategy and business credit consulting services.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Information We Collect</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                We collect information that you provide directly to us, including:
              </p>
              <ul className="list-disc pl-6 mb-6 space-y-2 text-base text-gray-700">
                <li>Personal identification information (name, email address, phone number)</li>
                <li>Business information (business name, type, revenue, years in operation)</li>
                <li>Financial information (credit scores, funding needs, financial goals)</li>
                <li>Documentation you provide for fundability assessment</li>
                <li>Communication preferences and correspondence with us</li>
              </ul>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">How We Use Your Information</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                We use the information we collect to:
              </p>
              <ul className="list-disc pl-6 mb-6 space-y-2 text-base text-gray-700">
                <li>Provide funding strategy and business credit consulting services</li>
                <li>Assess your fundability and create personalized strategies</li>
                <li>Communicate with you about your application and services</li>
                <li>Improve our services and customer experience</li>
                <li>Comply with legal obligations and protect our rights</li>
              </ul>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Information Sharing</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:
              </p>
              <ul className="list-disc pl-6 mb-6 space-y-2 text-base text-gray-700">
                <li>With your explicit consent</li>
                <li>With service providers who assist in our operations (under strict confidentiality agreements)</li>
                <li>When required by law or to protect our legal rights</li>
                <li>In connection with a business transaction (merger, acquisition, etc.)</li>
              </ul>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Data Security</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Your Rights</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                You have the right to:
              </p>
              <ul className="list-disc pl-6 mb-6 space-y-2 text-base text-gray-700">
                <li>Access the personal information we hold about you</li>
                <li>Request correction of inaccurate information</li>
                <li>Request deletion of your information (subject to legal obligations)</li>
                <li>Opt-out of marketing communications</li>
                <li>Withdraw consent where we rely on consent to process your information</li>
              </ul>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Cookies and Tracking</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                We use cookies and similar tracking technologies to improve your experience on our website, analyze usage patterns, and deliver personalized content. You can control cookie settings through your browser preferences.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Children's Privacy</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                Our services are not directed to individuals under the age of 18. We do not knowingly collect personal information from children.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Changes to This Policy</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new policy on this page and updating the "Last Updated" date.
              </p>

              <h2 className="text-2xl font-bold text-navy mb-4 mt-10">Contact Us</h2>
              <p className="text-base text-gray-700 leading-relaxed mb-6">
                If you have questions about this Privacy Policy or our privacy practices, please contact us through the information provided on our website.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
